import React from 'react';
import { Badge, Button } from '@superops/ui-design-system';
import { FormattedMessage } from 'react-intl';
import { formatNumber } from '@nile/reports/src/modules/charts/utils/chart-transformation/charts';

interface AlertOccurrentProps {
  /** The count to display in the badge */
  count: number;
  onViewClick?: () => void;
}

function AlertOccurrent({
  count,
  onViewClick
}: AlertOccurrentProps): React.ReactElement {
  // NOTE : This is a temporary fix to disable the view link if the count is 1 or less.
  // Final implementation will be done once the update from the UX team is provided.
  const isDisabled = count <= 1;

  const handleViewClick = () => {
    if (onViewClick && !isDisabled) {
      onViewClick();
    }
  };

  const formattedCount = formatNumber(count);

  const getBadgeStatus = (): 'attention' | 'warning' | 'critical' => {
    if (count <= 30) return 'attention';
    if (count <= 70) return 'warning';
    return 'critical';
  };

  return (
    <div className="flex actr tw-gap-3">
      <div className="flex jcc min-width-30">
        <Badge status={getBadgeStatus()} size="large">
          <span className="font-weight-600 f-14">{formattedCount}</span>
        </Badge>
      </div>
      {/* View button: plain variant when active, plainSecondary when disabled (count <= 1) */}
      {count > 1 && (
        <Button
          plain={!isDisabled}
          plainSecondary={isDisabled}
          onClick={handleViewClick}
        >
          <FormattedMessage id="role.operation.view" />
        </Button>
      )}
    </div>
  );
}

export default AlertOccurrent;
